import { gohualist } from '@/utils/hua'

const state = {
  type:1,
  scrolltop:0
}

const mutations = {
  SET_TYPE: (state, type) => {
    state.type = type
  },
  SET_SCROLLTOP: (state, scrolltop) => {
    state.scrolltop = scrolltop
  },
}

const actions = {
  changehuatype({ commit }, type) {
	  commit('SET_TYPE', type)
	  gohualist()
  },
  setscrolltop({ commit }, scrolltop) {
  	  commit('SET_SCROLLTOP', scrolltop)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
